import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "@/styles/nprogress.css";
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login"]; // белый список без перенаправления

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  document.title = getPageTitle(to.meta.title);

  if (to.path === "/login") {
    try {
      // Пробуем определить уже активную сессию, но без обновления токена:
      // гость на /login не должен дёргать заведомо безнадёжный refresh.
      await store.dispatch("user/getInfo", { skipRefresh: true });

      // Для принудительной смены пароля оставляем пользователя на /login.
      if (store.getters.mustChangePassword) {
        next();
        return;
      }

      next({ path: "/" });
    } catch (error) {
      next();
    }
    NProgress.done();
    return;
  }

  try {
    // Если профиль ещё не загружен в store (например, после reload), читаем его с бэка по cookie.
    const hasProfile = !!store.getters.username;
    if (!hasProfile) {
      await store.dispatch("user/getInfo");
    }

    // Пользователь должен сменить пароль: доступ только через /login.
    if (store.getters.mustChangePassword) {
      next({
        path: "/login",
        query: { redirect: to.path },
      });
      NProgress.done();
      return;
    }

    if (to.meta && to.meta.roles) {
      const userRoles = store.getters.roles;
      const hasPermission = userRoles.some((role) =>
        to.meta.roles.includes(role)
      );

      if (!hasPermission) {
        Message({
          message: "У вас нет прав доступа к этой странице",
          type: "error",
          duration: 3000,
        });
        next({ path: "/" });
        NProgress.done();
        return;
      }
    }

    next();
  } catch (error) {
    await store.dispatch("user/resetToken");

    if (whiteList.indexOf(to.path) !== -1) {
      next();
      return;
    }

    next({
      path: "/login",
      query: { redirect: to.path },
    });
    NProgress.done();
  }
});

router.afterEach(() => {
  NProgress.done();
});
